'use client';
// TODO: Fix React 19 compiler lint errors. See https://react.dev/learn/react-compiler
/* eslint-disable react-hooks/set-state-in-effect */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { MenuBarHeight } from '@components/shared/Menu/MenuBar';

type HeaderWrapperProps = {
  children: React.ReactNode;
  isNotificationBarVisible?: boolean; // From server - prevents CLS
  notificationBarHeight?: number; // From server - calculated height estimate
};

// Fallback minimum height if server calculation is not provided
const NOTIFICATION_BAR_MIN_HEIGHT = 60;

export default function HeaderWrapper({
  children,
  isNotificationBarVisible = false,
  notificationBarHeight: serverCalculatedHeight,
}: HeaderWrapperProps) {
  // Start with server-calculated height, fallback to minimum if visible but no height provided
  const initialHeight = serverCalculatedHeight ?? (isNotificationBarVisible ? NOTIFICATION_BAR_MIN_HEIGHT : 0);
  const [notificationBarHeight, setNotificationBarHeight] = useState(initialHeight);
  const elementRef = useRef<HTMLDivElement>(null);

  const adjustHeight = useCallback(() => {
    const element = document.getElementById('notification-bar');
    const newHeight = element ? element.clientHeight : 0;
    setNotificationBarHeight(newHeight);
  }, []);

  useEffect(() => {
    // Measure actual notification bar height after React renders
    // The ResizeObserver will automatically adjust if the bar is hidden/shown
    const observer = new ResizeObserver(adjustHeight);
    if (elementRef.current) {
      observer.observe(elementRef.current);
    }
    adjustHeight();

    return () => {
      observer.disconnect();
    };
  }, [adjustHeight]);

  // The fixed header holds both the notification bar and the 80px menu bar, so the
  // spacer must reserve the full header height to keep content from sliding underneath.
  const headerSpacerHeight = notificationBarHeight + MenuBarHeight;

  return (
    <>
      <div ref={elementRef} className="fixed z-50 w-full">
        {children}
      </div>
      <div
        style={{
          paddingBottom: headerSpacerHeight,
          minHeight: headerSpacerHeight,
        }}
      />
    </>
  );
}
